import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import CloseCreditResult from '../../components/close-credit-result/close-credit-result';
import AppPageMain from '../../modules/app-page/app-page--main';
import IconBtn from '../../modules/icon-btn/icon-btn';
import PageHeader from '../../modules/page-header';
import { RootState } from '../../types';

const CreditRepaymentResultPage: FC = () => {
  const history = useHistory();
  const resultState = useSelector(
    (state: RootState) => state.signResult.credit
  );

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                { link: '/assets', title: 'Активы' },
                { link: '#', title: 'Займы' },
              ]}
              iconType="assets"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <CloseCreditResult
              loading={false}
              submitBtn={
                <IconBtn
                  title="Закрыть и перейти в активы"
                  onClick={() => history.push('/assets')}
                />
              }
              success={!!resultState.success}
            />
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default CreditRepaymentResultPage;
